@if (allowMultiSelect) {
  <mat-form-field class="full-width">
    <mat-select  id="{{controlId}}"
      placeholder="{{ placeholder | translate}}"
      panelClass="mat-select-filter-override"
      [formControl]="model" multiple>
      <mat-select-trigger>
        @if (model.value?.length === 1) {
          <span>
            {{model.value ? model.value[0].caption : ''}}
          </span>
        }
        @if (model.value?.length > 1 && model.value?.length !== items?.length) {
          <span>
            <span>({{model.value?.length}} {{'i18n.common.ausgewaehlt'| translate}})</span>
          </span>
        }
        @if (model.value?.length === items?.length) {
          <span>
            <span>{{'i18n.common.all-ausgewaehlt'| translate}}</span>
          </span>
        }
      </mat-select-trigger>
      <app-select-check-all [model]="model" [values]="items">
      </app-select-check-all>
      @for (item of items; track item) {
        <mat-option [value]="item">{{ item.caption }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
} @else {
  <mat-form-field>
    <mat-select id="{{controlId}}" [formControl]="model">
      @for (item of items; track item) {
        <mat-option [value]="item">
          {{item.caption}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
}

